"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Widget = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Widget = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: ${({ theme }) => theme.spacing(3, 2)};
  flex: 1;
  border-radius: 4px;
  gap: ${({ theme }) => theme.spacing(1)};
`;
